<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "ApiState",
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }

      }
    },
    props: ["value"],
    data() {
      return {
        data: "",
        list: [{
            name: "未生效",
            value: 1
          },
          {
            name: "生效中",
            value: 2
          },
          {
            name: "作废",
            value: 3
          },
        ]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
